// extracted by mini-css-extract-plugin
export default {"home":"Question_home__3Nizo","hr":"Question_hr__rVEdC"};